import { memo } from 'react';

import { AccountProvisionBanner } from '~/components/AccountProvisioner/components/AccountProvisionBanner';
import { MaintenanceModeBanner } from '~/components/Banners/MaintenanceModeBanner';
import { PendingEmailBanner } from '~/components/Banners/PendingEmailBanner';
import { VerifyEmailBanner } from '~/components/Banners/VerifyEmail';
import { CreditUsageBannerAlert } from '~/components/CreditUsageBannerAlert';
import { StripeSubscriptionStatusBanner } from '~/components/SubscriptionStatusBanner';
import { WorkspaceStorageStatusBanner } from '~/components/WorkspaceStorageStatusBanner';
import { viewingCheckoutPageSelector } from '~/store/router/selectors';
import { useAirSelector } from '~/utils/ReduxUtils';

export const Banners = memo(() => {
  const isOnCheckoutPage = useAirSelector(viewingCheckoutPageSelector);

  if (isOnCheckoutPage) {
    return null;
  }

  return (
    <>
      <StripeSubscriptionStatusBanner />
      <WorkspaceStorageStatusBanner />
      <CreditUsageBannerAlert />
      <VerifyEmailBanner />
      <PendingEmailBanner />
      <MaintenanceModeBanner />
      <AccountProvisionBanner />
    </>
  );
});

Banners.displayName = 'Banners';
